module.exports = __webpack_public_path__ + "static/img/bg1.fbef20b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/bg1.jpg
// module id = wd6B
// module chunks = 1